import { combineReducers } from 'redux';

import faqsData from './faqsData';
import faqsOprs from './faqsOprs';

import { USER_OPR_STATE } from '../constants';

const rootReducer = combineReducers({ faqsData, faqsOprs });
// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default rootReducer;

// ==========
// Selectors:
// ==========
export function data(faqs) {
  return faqs.faqsData;
}

export function oprs(faqs) {
  return faqs.faqsOprs;
}

export function generalOprs(faqs) {
  return faqs.faqsOprs.generalOprs;
}

export function categoryOprs(faqs) {
  return faqs.faqsOprs.categoryOprs;
}

export function questionOprs(faqs) {
  return faqs.faqsOprs.questionOprs;
}

export function getEditPermissions(genOprs) {
  return genOprs;
}

export function getCategoryOprs(ctgOprs, ctg) {
  return ctgOprs[ctg.group_id];
}

export function getQuestionOprs(qstOprs, qst) {
  return qstOprs[qst.faq_id];
}

export function getQuestionOprsGroup(qstOprs, qstList) {
  return qstOprs;
}
